import { Width } from 'state/product-description/types';

export function getColumnCountForWidth(w: Width): number {
  switch (w) {
    case 'full':
      return 1;
    case 'three-quarters':
      // Not sure if it's the correct value. Neither if this method is usefull
      return 2;
    case 'half':
      return 2;
    case 'third':
      return 3;
    case 'two-thirds':
      return 2;
    case 'quarter':
      return 4;
    case 'sixth':
      return 6;
    default:
      throw new Error(`invalid width : '${w}'`);
  }
}

function getColumnSizeForWidth(w: Width): number {
  switch (w) {
    case 'full':
      return 12;
    case 'three-quarters':
      return 9;
    case 'half':
      return 6;
    case 'third':
      return 4;
    case 'two-thirds':
      return 8;
    case 'quarter':
      return 3;
    case 'sixth':
      return 2;
    default:
      throw new Error(`invalid width : '${w}'`);
  }
}

function getClassNameFromSize(colSize: number) {
  switch (colSize) {
    case 4:
      return 'col-12 col-lg-6 col-xl-4';
    case 3:
      return 'col-12 col-lg-6 col-xl-4 col-xxl-3';
    case 2:
      return 'col-12 col-lg-6 col-xl-4 col-xxl-2';
    default:
      return `col-12 col-lg-${colSize}`;
  }
}

export function getClassNameFromWidth(width: Width) {
  const columnSize = getColumnSizeForWidth(width);
  const colClassName = getClassNameFromSize(columnSize);
  return colClassName;
}
